import React from 'react';
import {
	Box,
	Alert,
	AlertIcon,
	AlertTitle,
	AlertDescription,
	CloseButton,
} from '@chakra-ui/react';
import { useAuthFlow } from '../../../services/Contexts/AuthFlowContext';

const AuthErrorDisplay = () => {
	const { error, clearError } = useAuthFlow();

	if (!error) return null;

	return (
		<Box>
			<Alert
				status='error'
				variant='left-accent'
				borderRadius='xl'
				bg='red.50'
				border='1px solid'
				borderColor='red.100'
				py={3}>
				<AlertIcon />
				<Box flex='1'>
					<AlertTitle fontSize='sm'>Couldn&apos;t sign you in</AlertTitle>
					<AlertDescription fontSize='sm'>{error}</AlertDescription>
				</Box>
				<CloseButton
					alignSelf='flex-start'
					size='sm'
					onClick={clearError}
				/>
			</Alert>
		</Box>
	);
};

export default AuthErrorDisplay;
